import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useScrollHeader, useIntoViewAnimation, useIsMobile } from '../../../hooks';
import Footer from "../../../components/Footer/Footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import './fcstIndex.less';
import 'swiper/css';
import 'swiper/css/pagination';
// import 'swiper/css/navigation';

import { Pagination, Navigation } from 'swiper/modules';

export default function FCST({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发

  const navigate = useNavigate();
  // FCST研究院
  const FcstList = [
    {
      title: '理论突破 - 弱视的皮层下受损',
      desc: '弱视患者的一个重要临床表现在于弱视眼对空间细节的敏感度降低，包括视锐度（眼睛辨别最小视角的能力）降低；对比度敏感度，尤其是对高空间频率（细密纹理）的对比度敏感度降低。...',
      date: '2024-10-31',
      img: '/images/home/news2.png',
      route: '/fcst/breakthroughTheory',
    },
    {
      title: '方法突破 - 结合增强现实的，可以针对弱视眼P通路进行矫正的双眼图像算法',
      desc: 'Xu等人在2010年证明了通过使用推拉（Push-pull）方法来减少眼优势（sensory eye dominance）的可能性。在训练过程中（图 C），受试者的任务是辨别非优势眼看到中的光栅朝向。 刺激首先向受试者的非优势眼呈现一个矩形框（注意提示），然后分别向双眼呈现一对正交光栅。...',
      date: '2024-10-31',
      img: '/images/home/news1.png',
      route: '/fcst/breakthroughMethod',
    },
    // {
    //   title: '什么是弱视？',
    //   desc: '弱视是一种视觉发育相关疾病，其特征为戴镜视力达不到同龄儿童正常视力下线或者两眼视力相差2行以上，且经眼科检查并未发现能够引起视力差的器质性病变。...',
    //   date: '2024-10-11',
    //   img: '/images/home/news3.png',
    //   route: '/fcst/identifyAmblyopia',
    // },
    // {
    //   title: '近视防控应该怎么做?',
    //   desc: <>
    //     首先判断是真性近视还是假性近视。<br />
    //     如果孩子出现"假性近视”，可以让孩子眼睛彻底放松，使眼睛慢慢恢复…
    //   </>,
    //   date: '2024-10-11',
    //   img: '/images/home/news4.png',
    //   route: '/fcst/identifyMyopia',
    // },
  ]
  const [newsData, setNewsData] = useState([])

  const newsData1 = [
    {
      title: '理论突破 - 弱视的皮层下受损',
      desc: '弱视患者的一个重要临床表现在于弱视眼对空间细节的敏感度降低，包括视锐度（眼睛辨别最小视角的能力）降低；对比度敏感度，尤其是对高空间频率（细密纹理）的对比度敏感度降低。...',
      date: '2024-10-31',
      img: '/images/home/news2.png',
      route: '/fcst/breakthroughTheory'
    },
    {
      title: '方法突破 - 结合增强现实的，可以针对弱视眼P通路进行矫正的双眼图像算法',
      desc: 'Xu等人在2010年证明了通过使用推拉（Push-pull）方法来减少眼优势（sensory eye dominance）的可能性。在训练过程中（图 C），受试者的任务是辨别非优势眼看到中的光栅朝向。 刺激首先向受试者的非优势眼呈现一个矩形框（注意提示），然后分别向双眼呈现一对正交光栅。...',
      date: '2024-10-31',
      img: '/images/home/news1.png',
      route: '/fcst/breakthroughMethod'
    },
  ]

  const newsData2 = [
    // {
    //   title: '什么是弱视？',
    //   desc: '弱视是一种视觉发育相关疾病，其特征为戴镜视力达不到同龄儿童正常视力下线或者两眼视力相差2行以上，且经眼科检查并未发现能够引起视力差的器质性病变。...',
    //   date: '2024-10-11',
    //   img: '/images/home/news3.png',
    //   route: '/fcst/identifyAmblyopia'
    // },
    // {
    //   title: '近视防控应该怎么做?',
    //   desc: <>
    //     首先判断是真性近视还是假性近视。<br />
    //     如果孩子出现"假性近视”，可以让孩子眼睛彻底放松，使眼睛慢慢恢复…
    //   </>,
    //   date: '2024-10-11',
    //   img: '/images/home/news4.png',
    //   route: '/fcst/identifyMyopia'
    // },
  ]

  const typeList = ['文献速递', '科普专栏', '所有文章']
  const [currentType, setCurrentType] = useState(2);
  const tabRefs = useRef([]);
  const [leftBtnHovered, setLeftBtnHovered] = useState(false)
  const [rightBtnHovered, setRightBtnHovered] = useState(false)

  useEffect(() => {
    if (currentType === 0) {
      setNewsData(newsData1)
    } else if (currentType === 1) {
      setNewsData(newsData2)
    } else {
      setNewsData([...newsData1, ...newsData2])
    }
  }, [currentType]);

  // 分页
  const [currentPage, setCurrentPage] = useState(1);
  const [loadedPages, setLoadedPages] = useState(1);
  const itemsPerPage = 9;
  // 计算总页数
  const totalPages = Math.ceil(newsData.length / itemsPerPage);
  // 检测是否是移动设备
  const isMobile = useIsMobile();
  // 获取当前应该显示的数据
  const getDisplayedData = () => {
    const endIndex = isMobile ? loadedPages * itemsPerPage : currentPage * itemsPerPage;
    const startIndex = isMobile ? 0 : (currentPage - 1) * itemsPerPage;
    return newsData.slice(startIndex, endIndex);
  };
  // 展开更多
  const handleLoadMore = () => {
    if (loadedPages < totalPages) {
      setLoadedPages(loadedPages + 1);
      if (!isMobile) {
        setCurrentPage(currentPage + 1);
      }
    }
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [direction, setDirection] = useState('next'); // 用于管理动画进出方向
  const [isInitialRender, setIsInitialRender] = useState(true);
  const scrollableRefs = useRef([]);

  useEffect(() => {
    setTimeout(() => {
      if (scrollableRefs.current[currentIndex]) {
        scrollableRefs.current[currentIndex].scrollTop = 0;
      }
    }, 100);
  }, [currentIndex])

  const [fcstCoverHovered, setFcstCoverHovered] = useState(false)
  const [fcstBottomHovered, setFcstBottomHovered] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
    // 在组件挂载后，将isInitialRender设置为false
    const timer = setTimeout(() => {
      setIsInitialRender(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  // PC端--进入动画
  const refPc = useRef('')
  useIntoViewAnimation({
    ref: refPc,
    threshold: 0.1,
    className: 'Fcst--ani',
  })

  // 移动端--进入动画
  const refMobile = useRef('')
  useIntoViewAnimation({
    ref: refMobile,
    threshold: 0.1,
    className: 'Fcst--aniMobile',
  })

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const handleNext = () => {
    if (currentIndex < FcstList.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  return <div className="Fcst">
    <div className='Fcst_cover'>
      <div className="pageMargin">
        <div className="CompanyNews_cover-blockTop">
          <div className="ofy_hidden">
            {/* PC端 */}
            <div className="Fcst_cover-topPc flex_row flex_jc-sb">
              <div className="fz_32 fw_700 lh_38" style={{ width: '50%' }}>FCST研究院</div>
              <div className="flex_row flex_jc-sb gap_16" style={{ width: '50%' }}>
                <div className="fz_20 fw_500 lh_24">Focusight®<br />Research institute</div>
                <div className="fz_16 fw_500 lh_24" style={{ width: '400px' }}>集视医疗全球高技术研发团队，在理论和方法均有突破，及时了解我们的最新项目进度和产品研发事项。</div>
              </div>
            </div>
            {/* 移动端 */}
            <div className='Fcst_cover-topMobile flex_row flex_jc-sb'>
              <div>
                <div className="fz_18 fw_700 lh_21">FCST研究院</div>
                <div className="fz_14 fw_500 lh_16 mt_4">Focusight®<br />Research institute</div>
              </div>
              <div className="fz_12 fw_500 lh_16" style={{ width: '170px' }}>集视医疗全球高技术研发团队，在理论和方法均有突破，及时了解我们的最新项目进度和产品研发事项。</div>
            </div>
          </div>
        </div>
        <div className="Fcst_cover-blockBottom">
          <div className="of_hidden">
            {/* PC端 */}
            <div ref={refPc} className="Fcst_cover-contentPc flex_row flex_jc-sb flex_ai-c gap_16">
              <div
                className={`Fcst_content-sliderBtn flex_auto ${currentIndex === 0 ? 'disabled' : ''}`}
                onClick={() => {
                  if (currentIndex !== 0) {
                    setPrevIndex(currentIndex);
                    setCurrentIndex(currentIndex - 1)
                    setDirection('prev');
                  }
                }}
              >
                <img
                  className='Wearable_product-sliderBtnIcon'
                  src='./images/home/whiteLeftIcon.png'
                  alt=''
                />
              </div>
              <div className="flex_full flex_row of_hidden" >
                {FcstList.map((item, index) =>
                  <div
                    key={index}
                    className={`flex_row flex_jc-sb gap_16 ${index === currentIndex
                      ? direction === 'next'
                        ? 'slide-in-next'
                        : 'slide-in-prev'
                      : index === prevIndex
                        ? direction === 'next'
                          ? 'slide-out-next'
                          : 'slide-out-prev'
                        : ''
                      }`}
                    style={{ width: '100%', display: index === currentIndex ? '' : 'none' }}
                  >
                    <div className="Fcst_cover-contentImg flex_center">
                      <img
                        style={{ width: '100%' }}
                        src={item.img}
                        alt=''
                      />
                    </div>
                    <div className="Fcst_cover-contentRight">
                      <div className="Fcst_cover-contentRightBlock">
                        <div className="of_hidden FcstScollbar" style={{ height: '100%', overflowY: 'auto' }} ref={(el) => scrollableRefs.current[index] = el}>
                          <div className={`Fcst_contentRight-itemBlock ${isInitialRender && currentIndex === 0 ? 'initial-animation' : ''}`}>
                            <div className="fz_18 fw_500 lh_21">{item.date}</div>
                            <div>
                              <div className="fz_32 fw_700 lh_38">{item.title}</div>
                              <div className="fz_16 fw_500 lh_24 multiline-ellipsis" style={{ marginTop: '5%' }}>{item.desc}</div>
                            </div>
                            <div
                              className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c'
                              onClick={() => navigate(item.route)}
                              onMouseEnter={() => setFcstCoverHovered(true)}
                              onMouseLeave={() => setFcstCoverHovered(false)}
                            >
                              <div>阅读文章</div>
                              <img
                                className='Wearable_product-rightArrow'
                                src={fcstCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                                alt=''
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>)}
              </div>
              <div
                className={`Fcst_content-sliderBtn flex_auto ${currentIndex === FcstList.length - 1 ? 'disabled' : ''}`}
                onClick={() => {
                  if (currentIndex !== FcstList.length - 1) {
                    setPrevIndex(currentIndex);
                    setCurrentIndex(currentIndex + 1)
                    setDirection('next');
                  }
                }}
              >
                <img
                  className='Wearable_product-sliderBtnIcon'
                  src='./images/home/whiteRightIcon.png'
                  alt=''
                />
              </div>
            </div>
            {/* Swiper组件实现 */}
            {/* <div ref={refPc} className="Fcst_cover-contentPc flex_row flex_ai-c gap_20">
              <div
                className={`Fcst_cover-swiperButtonPrev flex_center ${currentIndex === 0 ? 'disabled' : ''}`}
                onClick={handlePrev}
              >
                <img
                  className='Wearable_product-sliderBtnIcon'
                  src='./images/home/whiteLeftIcon.png'
                  alt=''
                />
              </div>
              <Swiper
                style={{ width: 'calc(100% - 180px)' }}
                navigation={{
                  nextEl: '.Fcst_cover-swiperButtonNext',
                  prevEl: '.Fcst_cover-swiperButtonPrev',
                }}
                modules={[Navigation]}
              >
                {FcstList.map((item, index) => <SwiperSlide key={index} className='flex_row flex_jc-c'>
                  <div className='flex_row flex_jc-sb gap_16'>
                    <div className="Fcst_cover-contentImg flex_center">
                      <img
                        style={{ width: '100%' }}
                        src={item.img}
                        alt=''
                      />
                    </div>
                    <div className="Fcst_cover-contentRight">
                      <div className="Fcst_cover-contentRightBlock">
                        <div className="of_hidden" style={{ height: '100%' }}>
                          <div className={`Fcst_contentRight-itemBlock ${isInitialRender && currentIndex === 0 ? 'initial-animation' : ''}`}>
                            <div className="fz_18 fw_500 lh_21">{item.date}</div>
                            <div>
                              <div className="fz_32 fw_700 lh_38 ellipsis">{item.title}</div>
                              <div className="fz_16 fw_500 lh_24 multiline-ellipsis" style={{ marginTop: '5%' }}>{item.desc}</div>
                            </div>
                            <div
                              className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c'
                              onClick={() => navigate(item.route)}
                              onMouseEnter={() => setFcstCoverHovered(true)}
                              onMouseLeave={() => setFcstCoverHovered(false)}
                            >
                              <div>阅读文章</div>
                              <img
                                className='Wearable_product-rightArrow'
                                src={fcstCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                                alt=''
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>)}
              </Swiper>
              <div
                className={`Fcst_cover-swiperButtonNext flex_center ${currentIndex >= FcstList.length - 1 ? 'disabled' : ''}`}
                onClick={handleNext}
              >
                <img
                  className='Wearable_product-sliderBtnIcon'
                  src='./images/home/whiteRightIcon.png'
                  alt=''
                />
              </div>
            </div> */}
            {/* 移动端 */}
            <div ref={refMobile} className="Fcst_cover-contentMobile">
              <Swiper
                className='Fcst_cover-swiper'
                pagination={true}
                modules={[Pagination]}
              >
                {FcstList.map((item, index) => <SwiperSlide key={index}>
                  <div
                    className='flex_col flex_jc-sb gap_12'
                    style={{ width: '100%' }}
                  >
                    <div className="Fcst_cover-contentImg flex_center">
                      <img
                        style={{ width: '100%' }}
                        src={item.img}
                        alt=''
                      />
                    </div>
                    <div className="Fcst_cover-contentRight">
                      <div className="Fcst_cover-contentRightBlock">
                        <div className="of_hidden" style={{ height: '100%' }}>
                          <div className={`Fcst_contentRight-itemBlock ${isInitialRender && currentIndex === 0 ? 'initial-animation' : ''}`}>
                            <div className="fz_12 fw_500 lh_14">{item.date}</div>
                            <div>
                              <div className="fz_18 fw_700 lh_21">{item.title}</div>
                              <div className="fz_12 fw_500 lh_16 mt_10">{item.desc}</div>
                            </div>
                            <div
                              className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c'
                              onClick={() => navigate(item.route)}
                              onMouseEnter={() => setFcstCoverHovered(true)}
                              onMouseLeave={() => setFcstCoverHovered(false)}
                            >
                              <div>阅读文章</div>
                              <img
                                className='Wearable_product-rightArrowMobile'
                                src={fcstCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                                alt=''
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>)}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="Fcst_bottomContent bgc_F5F9FD">
      <div className="pageMargin">
        <div className="CompanyNews_content-top">
          <div className="of_hidden">
            <div className="CompanyNews_content-topBlock c_85899E flex_row flex_jc-c">
              {typeList.map((i, index) => <div
                key={index}
                ref={el => tabRefs.current[index] = el}
                className={`Fcst_bottomContent-typeItem cur_p ${index === currentType ? 'active' : ''}`}
                onClick={(() => setCurrentType(index))}
              >
                {i}</div>)}
            </div>
          </div>
        </div>
        <div className="Fcst_bottomContent-block">
          {getDisplayedData().map((item, index) => <div
            key={index}
            className="CompanyNews_content-item"
            onClick={() => {
              if (isMobile) {
                navigate(item.route)
              }
            }}
          >
            <div className="CompanyNews_content-itemImg flex_center">
              <img
                style={{ width: '100%' }}
                src={item.img}
                alt=''
              />
              <div className="Fcst_bottomContent-btnBlock flex_center">
                <div
                  className="Fcst_bottomContent-btn cur_p"
                  onClick={(() => navigate(item.route))}
                  onMouseEnter={() => setFcstBottomHovered(true)}
                  onMouseLeave={() => setFcstBottomHovered(false)}
                >
                  <div className="fz_18 fw_500 lh_21">阅读文章</div>
                  <img
                    className='Wearable_product-rightArrow'
                    src={fcstBottomHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                    alt=''
                  />
                </div>
              </div>
            </div>
            <div className="CompanyNews_content-itemDate c_85899E">{item.date}</div>
            <div className="CompanyNews_content-itemTitle of_ellipsis">{item.title}</div>
            <div className="CompanyNews_content-itemDesc c_85899E ellipsis_2">{item.desc}</div>
          </div>)}
        </div>
        {/* PC端分页 */}
        <div className="CompanyNews_pageBlockPc">
          {newsData.length > 9 && <div className="Fcst_bottomContent-page flex_row flex_jc-c flex_ai-c">
            <div
              className="CompanyNews_content-leftBtn flex_center"
              style={{ cursor: currentPage === 1 ? 'no-drop' : 'pointer' }}
              onMouseEnter={() => setLeftBtnHovered(true)}
              onMouseLeave={() => setLeftBtnHovered(false)}
              onClick={(() => {
                if (currentPage !== 1) {
                  setCurrentPage(currentPage - 1)
                }
              })}
            >
              <img
                className='Wearable_product-sliderBtnIcon'
                src={leftBtnHovered ? './images/home/whiteLeftIcon.png' : './images/home/blackLeftIcon.png'}
                alt=''
              />
            </div>
            <div className="flex_row gap_54 ml_86 mr_86">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <div
                  key={page}
                  className={`fz_24 fw_500 lh_28 cur_p ${currentPage === page ? 'c_00' : 'c_85899E'}`}
                  onClick={() => { setCurrentPage(page) }}
                >
                  {page}</div>
              ))}
            </div>
            <div
              className="CompanyNews_content-leftBtn flex_center"
              style={{ cursor: currentPage === totalPages ? 'no-drop' : 'pointer' }}
              onMouseEnter={() => setRightBtnHovered(true)}
              onMouseLeave={() => setRightBtnHovered(false)}
              onClick={(() => {
                if (currentPage !== totalPages)
                  setCurrentPage(currentPage + 1)
              })}
            >
              <img
                className='Wearable_product-sliderBtnIcon'
                src={rightBtnHovered ? './images/home/whiteRightIcon.png' : './images/home/blackRightIcon.png'}
                alt=''
              />
            </div>
          </div>}
        </div>
        {/* 移动端——展开更多 */}
        {loadedPages < totalPages && <div className='CompanyNews_pageBlockMobile flex_row flex_jc-c'>
          <div
            className='CompanyNews_mobileBtn flex_row flex_jc-c flex_ai-c'
            onClick={handleLoadMore}
          >
            <div>展开更多</div>
            <img
              className='Wearable_product-rightArrowMobile'
              src='./images/home/arrow-down-blackLine.png'
              alt=''
            />
          </div>
        </div>}
      </div>
    </div>
    <Footer />
  </div>
}
